import { useApplicationContext } from '../../utils/applicationContext';

// TODO: Удалить в CD-206498
export const useIsNewbuildingBrokerEntryRedesignEnabled = () => {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('newbuildingBrokerEntryRedesign.Enabled');
};
